// 发件人头像（详情页 / 列表 / Dashboard 共用）。
//
// 图标走本站 /api/v1/sender-icons/<域>：Worker 服务端代理 BIMI / Google / DDG 并逐级回退到主域，
// 第三方只看到 Cloudflare 出口，拿不到用户 IP、形不成已读回执 → 不受反追踪开关约束。
// 404（全部来源未命中）或加载失败 → 首字母方块。
// useBlockRemoteImages 仍供邮件正文沙箱使用（远程图片 / 追踪像素）。

import { useState } from 'react';

import { useTrackingProtection } from '../lib/settings.js';

/** 反追踪是否生效（加载中 / 失败按生效处理，宁可少一个图标也不外发请求）。 */
export function useBlockRemoteImages(): boolean {
  return useTrackingProtection().data?.enabled ?? true;
}

function iconUrl(fromAddress: string): string {
  const domain = (fromAddress.split('@')[1] ?? '').trim().toLowerCase();
  return domain ? `/api/v1/sender-icons/${encodeURIComponent(domain)}` : '';
}

export function SenderAvatar({
  fromAddress,
  fromName,
  size = 20,
  className = '',
  fallbackClassName = 'text-[10px]',
}: {
  fromAddress: string;
  fromName?: string | null | undefined;
  /** 像素尺寸（img width/height 属性）；实际显示尺寸由 className 控制 */
  size?: number;
  className?: string;
  /** 首字母方块的字号等附加样式 */
  fallbackClassName?: string;
}) {
  const icon = iconUrl(fromAddress);
  // 记录失败的 URL 而非布尔：同一组件实例换了发件人时自动重试，不沿用上一个的失败状态
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (icon && failedUrl !== icon) {
    return (
      <img
        src={icon}
        alt=""
        width={size}
        height={size}
        referrerPolicy="no-referrer"
        className={`shrink-0 rounded ${className}`}
        onError={() => setFailedUrl(icon)}
      />
    );
  }
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded bg-slate-200 font-medium text-slate-600 dark:bg-slate-700 dark:text-slate-200 ${fallbackClassName} ${className}`}
    >
      {(fromName?.[0] ?? fromAddress[0] ?? '?').toUpperCase()}
    </div>
  );
}
